import React from 'react';
import ReactDOM from 'react-dom/client';
import {createHashRouter, RouterProvider} from "react-router-dom";
import 'react-tabulator/css/tabulator_bootstrap5.css'
import './index.css';
import ErrorPage from "./ErrorPage";
import Finance from './Finance';
import Accounts, {loader as accountsLoader} from './Accounts';
import Portfolio from './Portfolio';
import Transactions, {loader as transactionsLoader} from './Transactions';
import Spending, {loader as spendingLoader} from './Spending';
import TaxReports, {loader as taxReportsLoader} from './TaxReports';
import ExpenseTransactions, {loader as expenseTransactionsLoader} from './ExpenseTransactions';
import TransactionFilePathChooser, {loader as transactionFilePathChooserLoader} from './TransactionFilePathChooser';
import TransactionFileChooser, {loader as transactionFileChooserLoader} from './TransactionFileChooser';
import TransactionFileDetail, {loader as transactionFileDetailLoader} from './TransactionFileDetail';
import ParsingConfigCreateProcessList, {loader as parsingConfigCreateProcessListLoader} from './ParsingConfigCreateProcessList';
import ParsingConfigCreateProcess, {loader as parsingConfigCreateProcessLoader} from './ParsingConfigCreateProcess';
import Problems, {loader as problemsLoader} from './Problems';
import RawTransactionDetail, {loader as rawTransactionDetailLoader} from './RawTransactionDetail';
import Balance, {loader as balanceLoader} from './Balance';
import Settings from './Settings';
import reportWebVitals from './reportWebVitals';

const router = createHashRouter([
  {
    path: "/",
    element: <Finance />,
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <Accounts />,
        loader: accountsLoader,
      },
      {
        path: "/accounts",
        element: <Accounts />,
        loader: accountsLoader,
      },
      {
        path: "/charts",
        element: <Portfolio />,
      },
      {
        path: "/balance",
        element: <Balance />,
        loader: balanceLoader,
      },
      {
        path: "/transactions",
        element: <Transactions />,
        loader: transactionsLoader,
      },
      {
        path: "/spending",
        element: <Spending />,
        loader: spendingLoader,
      },
      {
        path: "/tax",
        element: <TaxReports />,
        loader: taxReportsLoader,
      },
      {
        path: "/expense_transactions",
        element: <ExpenseTransactions />,
        loader: expenseTransactionsLoader,
      },
      {
        path: "/file/:rawFileRecordId",
        element: <TransactionFileDetail />,
        loader: transactionFileDetailLoader,
      },
      {
        path: "/files/:pathPrefix",
        element: <TransactionFileChooser />,
        loader: transactionFileChooserLoader,
      },
      {
        path: "/files",
        element: <TransactionFilePathChooser />,
        loader: transactionFilePathChooserLoader,
      },
      {
        path: "/parsing",
        element: <ParsingConfigCreateProcessList />,
        loader: parsingConfigCreateProcessListLoader,
      },
      {
        path: "/parsing/:createProcess",
        element: <ParsingConfigCreateProcess />,
        loader: parsingConfigCreateProcessLoader,
      },
      {
        path: "/raw_transaction/:rawTransactionRecordId",
        element: <RawTransactionDetail />,
        loader: rawTransactionDetailLoader,
      },
      {
        path: "/problems",
        element: <Problems />,
        loader: problemsLoader,
      },
      {
        path: "/settings",
        element: <Settings />,
      },
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
